export default __webpack_public_path__ + "c5da32edbd58edf91de2d2f19a69bf1d.svg";